import { useRef } from 'react'

import { APP_NAME } from '@zet/end-points'
import * as MediaLibrary from 'expo-media-library'
import * as Sharing from 'expo-sharing'
import { captureRef } from 'react-native-view-shot'

interface DownloadAndShareProps {
  width?: number
  height?: number
  onSuccess?: () => void
  onError?: () => void
}

const useDownloadAndShare = ({
  width = 360 * 3,
  height = 455 * 3,
  onSuccess,
  onError,
}: DownloadAndShareProps) => {
  const ref = useRef()

  const capture = async () => {
    try {
      return await captureRef(ref?.current, {
        result: 'tmpfile',
        height: height,
        width: width,
        quality: 1,
        format: 'png',
        fileName: `${APP_NAME}_${Date.now()}`,
      })
    } catch (error) {
      return
    }
  }

  const share = async () => {
    try {
      const result = await capture()
      if (!result) return

      if (!(await Sharing.isAvailableAsync())) {
        return
      }

      await Sharing.shareAsync(result, {
        mimeType: 'image/png',
        dialogTitle: 'Check out this image!',
        UTI: 'image/png',
      })
    } catch (error) {
      console.log(error)
    }
  }

  const download = async () => {
    try {
      const { status, canAskAgain } = await MediaLibrary.requestPermissionsAsync(true, ["photo"])

      if (status !== 'granted') {
        if (!canAskAgain) {
          alert('Please enable media permissions in settings.')
        }
        return
      }

      const result = await capture()
      if (!result) return

      await MediaLibrary.createAssetAsync(result)
      onSuccess?.()
    } catch (error) {
      console.log('Download failed:', error)
      onError?.()
    }
  }

  return { ref, download, share }
}

export { useDownloadAndShare }
